/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CostreportV1beta1ChangeReportingMonetizationSubscriptionPlanRequest } from '../models';
// @ts-ignore
import type { CostreportV1beta1ChangeReportingMonetizationSubscriptionPlanResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1ConfirmReportingMonetizationCheckoutSessionRequest } from '../models';
// @ts-ignore
import type { CostreportV1beta1ConfirmReportingMonetizationCheckoutSessionResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1CreateReportingMonetizationCheckoutSessionRequest } from '../models';
// @ts-ignore
import type { CostreportV1beta1CreateReportingMonetizationCheckoutSessionResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetCastAIFeeConfigResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetClusterReportingCapabilitiesResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetEgressdScriptResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetGpuMetricsExporterScriptResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetReliabilityMetricsScriptResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetReportingMonetizationBillingPortalRequest } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetReportingMonetizationBillingPortalResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetReportingMonetizationPricesResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetReportingMonetizationReadinessResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1GetReportingMonetizationStatusResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1UpdateCastAIFeeConfigRequest } from '../models';
// @ts-ignore
import type { CostreportV1beta1UpdateCastAIFeeConfigResponse } from '../models';
// @ts-ignore
import type { CostreportV1beta1UpdateOAJStateRequest } from '../models';
/**
 * ReportConfigurationAPIApi - axios parameter creator
 * @export
 */
export const ReportConfigurationAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Creates a Stripe plan-change confirmation session for the requested tier and returns its URL. The user is redirected to the Stripe billing portal, which shows the prorated cost of the change before requiring explicit confirmation.
         * @param {CostreportV1beta1ChangeReportingMonetizationSubscriptionPlanRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIChangeReportingMonetizationSubscriptionPlan: async (body: CostreportV1beta1ChangeReportingMonetizationSubscriptionPlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reportConfigurationAPIChangeReportingMonetizationSubscriptionPlan', 'body', body)
            const localVarPath = `/v1/cost-reports/reporting-monetization/change-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirms a completed Stripe Checkout session and persists the subscription (status -> paid).
         * @param {CostreportV1beta1ConfirmReportingMonetizationCheckoutSessionRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIConfirmReportingMonetizationCheckoutSession: async (body: CostreportV1beta1ConfirmReportingMonetizationCheckoutSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reportConfigurationAPIConfirmReportingMonetizationCheckoutSession', 'body', body)
            const localVarPath = `/v1/cost-reports/reporting-monetization/checkout-session/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a Stripe Checkout subscription session for the requested tier and returns its URL.
         * @param {CostreportV1beta1CreateReportingMonetizationCheckoutSessionRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPICreateReportingMonetizationCheckoutSession: async (body: CostreportV1beta1CreateReportingMonetizationCheckoutSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reportConfigurationAPICreateReportingMonetizationCheckoutSession', 'body', body)
            const localVarPath = `/v1/cost-reports/reporting-monetization/checkout-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the CAST AI fee constants configured for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetCastAIFeeConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/cost-reports/organization/cast-ai-fee-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns information about the reporting capabilities for a specific cluster.
         * @param {string} clusterId 
         * @param {string} startTime Filter items to include from specified time.
         * @param {string} endTime Filter items to include up to specified time.
         * @param {Array<string>} [filterWorkloadNames] 
         * @param {ReportConfigurationAPIGetClusterReportingCapabilitiesFilterLabelsOperatorEnum} [filterLabelsOperator] 
         * @param {Array<string>} [filterWorkloadTypes] 
         * @param {Array<string>} [filterNamespaces] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetClusterReportingCapabilities: async (clusterId: string, startTime: string, endTime: string, filterWorkloadNames?: Array<string>, filterLabelsOperator?: ReportConfigurationAPIGetClusterReportingCapabilitiesFilterLabelsOperatorEnum, filterWorkloadTypes?: Array<string>, filterNamespaces?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('reportConfigurationAPIGetClusterReportingCapabilities', 'clusterId', clusterId)
            // verify required parameter 'startTime' is not null or undefined
            assertParamExists('reportConfigurationAPIGetClusterReportingCapabilities', 'startTime', startTime)
            // verify required parameter 'endTime' is not null or undefined
            assertParamExists('reportConfigurationAPIGetClusterReportingCapabilities', 'endTime', endTime)
            const localVarPath = `/v1/cost-reports/clusters/{clusterId}/reporting-capabilities`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (filterWorkloadNames) {
                localVarQueryParameter['filter.workloadNames'] = filterWorkloadNames;
            }

            if (filterLabelsOperator !== undefined) {
                localVarQueryParameter['filter.labelsOperator'] = filterLabelsOperator;
            }

            if (filterWorkloadTypes) {
                localVarQueryParameter['filter.workloadTypes'] = filterWorkloadTypes;
            }

            if (filterNamespaces) {
                localVarQueryParameter['filter.namespaces'] = filterNamespaces;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns single command for external cluster with egressd installation script.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetEgressdScript: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('reportConfigurationAPIGetEgressdScript', 'clusterId', clusterId)
            const localVarPath = `/v1/kubernetes/clusters/{clusterId}/egressd-script`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns egressd installation script template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetEgressdScriptTemplate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/scripts/egressd/install.sh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Deprecated] Use Kvisor for gpu-metrics collection. Returns single command for external cluster with gpu-metrics-exporter installation script.
         * @param {string} clusterId The ID of the cluster that will install gpu-metrics-exporter.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetGpuMetricsExporterScript: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('reportConfigurationAPIGetGpuMetricsExporterScript', 'clusterId', clusterId)
            const localVarPath = `/v1/kubernetes/clusters/{clusterId}/gpu-metrics-exporter-script`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns gpu-metrics-exporter installation script template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetGpuMetricsExporterScriptTemplate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/scripts/gpu-metrics-exporter/install.sh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns single command for external cluster with reliability-metrics (kvisor) installation script.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReliabilityMetricsScript: async (clusterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('reportConfigurationAPIGetReliabilityMetricsScript', 'clusterId', clusterId)
            const localVarPath = `/v1/kubernetes/clusters/{clusterId}/reliability-metrics-script`
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns reliability-metrics (kvisor) installation script template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReliabilityMetricsScriptTemplate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/scripts/reliability-metrics/install.sh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a Stripe billing-portal session for the organization\'s customer and returns its URL.
         * @param {CostreportV1beta1GetReportingMonetizationBillingPortalRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReportingMonetizationBillingPortal: async (body: CostreportV1beta1GetReportingMonetizationBillingPortalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reportConfigurationAPIGetReportingMonetizationBillingPortal', 'body', body)
            const localVarPath = `/v1/cost-reports/reporting-monetization/billing-portal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the reporting-monetization tier prices (amount, currency, billing interval), fetched live from Stripe so consumers always show current prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReportingMonetizationPrices: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/cost-reports/reporting-monetization/prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the reporting-monetization onboarding readiness signals for the organization: which usage milestones (connected cluster, allocation groups, budgets, OpsPilot questions) have already been reached.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReportingMonetizationReadiness: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/cost-reports/reporting-monetization/readiness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns the reporting-monetization trial status for an organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReportingMonetizationStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/cost-reports/reporting-monetization/state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks an organization as eligible for the reporting-monetization trial flow. Enables the feature flag for the org and creates a pending trial record.
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIMarkOrgEligibleForReportingMonetization: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reportConfigurationAPIMarkOrgEligibleForReportingMonetization', 'body', body)
            const localVarPath = `/v1/cost-reports/reporting-monetization/mark-eligible`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Starts the reporting-monetization trial for an organization. Transitions a pending trial to active and sets started_at/expires_at.
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIStartReportingMonetizationTrial: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reportConfigurationAPIStartReportingMonetizationTrial', 'body', body)
            const localVarPath = `/v1/cost-reports/reporting-monetization/start-trial`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates or replaces the CAST AI fee constants for the organization.
         * @param {CostreportV1beta1UpdateCastAIFeeConfigRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIUpdateCastAIFeeConfig: async (body: CostreportV1beta1UpdateCastAIFeeConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reportConfigurationAPIUpdateCastAIFeeConfig', 'body', body)
            const localVarPath = `/v1/cost-reports/organization/cast-ai-fee-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates organization OAJ state.
         * @param {CostreportV1beta1UpdateOAJStateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIUpdateOAJState: async (body: CostreportV1beta1UpdateOAJStateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reportConfigurationAPIUpdateOAJState', 'body', body)
            const localVarPath = `/v1/cost-reports/organization/oaj-state`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportConfigurationAPIApi - functional programming interface
 * @export
 */
export const ReportConfigurationAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportConfigurationAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Creates a Stripe plan-change confirmation session for the requested tier and returns its URL. The user is redirected to the Stripe billing portal, which shows the prorated cost of the change before requiring explicit confirmation.
         * @param {CostreportV1beta1ChangeReportingMonetizationSubscriptionPlanRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIChangeReportingMonetizationSubscriptionPlan(body: CostreportV1beta1ChangeReportingMonetizationSubscriptionPlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1ChangeReportingMonetizationSubscriptionPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIChangeReportingMonetizationSubscriptionPlan(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIChangeReportingMonetizationSubscriptionPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirms a completed Stripe Checkout session and persists the subscription (status -> paid).
         * @param {CostreportV1beta1ConfirmReportingMonetizationCheckoutSessionRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIConfirmReportingMonetizationCheckoutSession(body: CostreportV1beta1ConfirmReportingMonetizationCheckoutSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1ConfirmReportingMonetizationCheckoutSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIConfirmReportingMonetizationCheckoutSession(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIConfirmReportingMonetizationCheckoutSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a Stripe Checkout subscription session for the requested tier and returns its URL.
         * @param {CostreportV1beta1CreateReportingMonetizationCheckoutSessionRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPICreateReportingMonetizationCheckoutSession(body: CostreportV1beta1CreateReportingMonetizationCheckoutSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1CreateReportingMonetizationCheckoutSessionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPICreateReportingMonetizationCheckoutSession(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPICreateReportingMonetizationCheckoutSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the CAST AI fee constants configured for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetCastAIFeeConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetCastAIFeeConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetCastAIFeeConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetCastAIFeeConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns information about the reporting capabilities for a specific cluster.
         * @param {string} clusterId 
         * @param {string} startTime Filter items to include from specified time.
         * @param {string} endTime Filter items to include up to specified time.
         * @param {Array<string>} [filterWorkloadNames] 
         * @param {ReportConfigurationAPIGetClusterReportingCapabilitiesFilterLabelsOperatorEnum} [filterLabelsOperator] 
         * @param {Array<string>} [filterWorkloadTypes] 
         * @param {Array<string>} [filterNamespaces] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetClusterReportingCapabilities(clusterId: string, startTime: string, endTime: string, filterWorkloadNames?: Array<string>, filterLabelsOperator?: ReportConfigurationAPIGetClusterReportingCapabilitiesFilterLabelsOperatorEnum, filterWorkloadTypes?: Array<string>, filterNamespaces?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetClusterReportingCapabilitiesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetClusterReportingCapabilities(clusterId, startTime, endTime, filterWorkloadNames, filterLabelsOperator, filterWorkloadTypes, filterNamespaces, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetClusterReportingCapabilities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns single command for external cluster with egressd installation script.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetEgressdScript(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetEgressdScriptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetEgressdScript(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetEgressdScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns egressd installation script template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetEgressdScriptTemplate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetEgressdScriptTemplate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetEgressdScriptTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary [Deprecated] Use Kvisor for gpu-metrics collection. Returns single command for external cluster with gpu-metrics-exporter installation script.
         * @param {string} clusterId The ID of the cluster that will install gpu-metrics-exporter.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetGpuMetricsExporterScript(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetGpuMetricsExporterScriptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetGpuMetricsExporterScript(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetGpuMetricsExporterScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns gpu-metrics-exporter installation script template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetGpuMetricsExporterScriptTemplate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetGpuMetricsExporterScriptTemplate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetGpuMetricsExporterScriptTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns single command for external cluster with reliability-metrics (kvisor) installation script.
         * @param {string} clusterId The ID of the cluster.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetReliabilityMetricsScript(clusterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetReliabilityMetricsScriptResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetReliabilityMetricsScript(clusterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetReliabilityMetricsScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns reliability-metrics (kvisor) installation script template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetReliabilityMetricsScriptTemplate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetReliabilityMetricsScriptTemplate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetReliabilityMetricsScriptTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a Stripe billing-portal session for the organization\'s customer and returns its URL.
         * @param {CostreportV1beta1GetReportingMonetizationBillingPortalRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetReportingMonetizationBillingPortal(body: CostreportV1beta1GetReportingMonetizationBillingPortalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetReportingMonetizationBillingPortalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetReportingMonetizationBillingPortal(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetReportingMonetizationBillingPortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the reporting-monetization tier prices (amount, currency, billing interval), fetched live from Stripe so consumers always show current prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetReportingMonetizationPrices(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetReportingMonetizationPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetReportingMonetizationPrices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetReportingMonetizationPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the reporting-monetization onboarding readiness signals for the organization: which usage milestones (connected cluster, allocation groups, budgets, OpsPilot questions) have already been reached.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetReportingMonetizationReadiness(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetReportingMonetizationReadinessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetReportingMonetizationReadiness(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetReportingMonetizationReadiness']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns the reporting-monetization trial status for an organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIGetReportingMonetizationStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1GetReportingMonetizationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIGetReportingMonetizationStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIGetReportingMonetizationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks an organization as eligible for the reporting-monetization trial flow. Enables the feature flag for the org and creates a pending trial record.
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIMarkOrgEligibleForReportingMonetization(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIMarkOrgEligibleForReportingMonetization(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIMarkOrgEligibleForReportingMonetization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Starts the reporting-monetization trial for an organization. Transitions a pending trial to active and sets started_at/expires_at.
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIStartReportingMonetizationTrial(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIStartReportingMonetizationTrial(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIStartReportingMonetizationTrial']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates or replaces the CAST AI fee constants for the organization.
         * @param {CostreportV1beta1UpdateCastAIFeeConfigRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIUpdateCastAIFeeConfig(body: CostreportV1beta1UpdateCastAIFeeConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CostreportV1beta1UpdateCastAIFeeConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIUpdateCastAIFeeConfig(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIUpdateCastAIFeeConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Updates organization OAJ state.
         * @param {CostreportV1beta1UpdateOAJStateRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportConfigurationAPIUpdateOAJState(body: CostreportV1beta1UpdateOAJStateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportConfigurationAPIUpdateOAJState(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportConfigurationAPIApi.reportConfigurationAPIUpdateOAJState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportConfigurationAPIApi - factory interface
 * @export
 */
export const ReportConfigurationAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportConfigurationAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Creates a Stripe plan-change confirmation session for the requested tier and returns its URL. The user is redirected to the Stripe billing portal, which shows the prorated cost of the change before requiring explicit confirmation.
         * @param {ReportConfigurationAPIApiReportConfigurationAPIChangeReportingMonetizationSubscriptionPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIChangeReportingMonetizationSubscriptionPlan(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIChangeReportingMonetizationSubscriptionPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1ChangeReportingMonetizationSubscriptionPlanResponse> {
            return localVarFp.reportConfigurationAPIChangeReportingMonetizationSubscriptionPlan(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirms a completed Stripe Checkout session and persists the subscription (status -> paid).
         * @param {ReportConfigurationAPIApiReportConfigurationAPIConfirmReportingMonetizationCheckoutSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIConfirmReportingMonetizationCheckoutSession(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIConfirmReportingMonetizationCheckoutSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1ConfirmReportingMonetizationCheckoutSessionResponse> {
            return localVarFp.reportConfigurationAPIConfirmReportingMonetizationCheckoutSession(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a Stripe Checkout subscription session for the requested tier and returns its URL.
         * @param {ReportConfigurationAPIApiReportConfigurationAPICreateReportingMonetizationCheckoutSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPICreateReportingMonetizationCheckoutSession(requestParameters: ReportConfigurationAPIApiReportConfigurationAPICreateReportingMonetizationCheckoutSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1CreateReportingMonetizationCheckoutSessionResponse> {
            return localVarFp.reportConfigurationAPICreateReportingMonetizationCheckoutSession(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the CAST AI fee constants configured for the organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetCastAIFeeConfig(options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetCastAIFeeConfigResponse> {
            return localVarFp.reportConfigurationAPIGetCastAIFeeConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns information about the reporting capabilities for a specific cluster.
         * @param {ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetClusterReportingCapabilities(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilitiesRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetClusterReportingCapabilitiesResponse> {
            return localVarFp.reportConfigurationAPIGetClusterReportingCapabilities(requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, requestParameters.filterWorkloadNames, requestParameters.filterLabelsOperator, requestParameters.filterWorkloadTypes, requestParameters.filterNamespaces, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns single command for external cluster with egressd installation script.
         * @param {ReportConfigurationAPIApiReportConfigurationAPIGetEgressdScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetEgressdScript(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIGetEgressdScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetEgressdScriptResponse> {
            return localVarFp.reportConfigurationAPIGetEgressdScript(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns egressd installation script template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetEgressdScriptTemplate(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reportConfigurationAPIGetEgressdScriptTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Deprecated] Use Kvisor for gpu-metrics collection. Returns single command for external cluster with gpu-metrics-exporter installation script.
         * @param {ReportConfigurationAPIApiReportConfigurationAPIGetGpuMetricsExporterScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetGpuMetricsExporterScript(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIGetGpuMetricsExporterScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetGpuMetricsExporterScriptResponse> {
            return localVarFp.reportConfigurationAPIGetGpuMetricsExporterScript(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns gpu-metrics-exporter installation script template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetGpuMetricsExporterScriptTemplate(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reportConfigurationAPIGetGpuMetricsExporterScriptTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns single command for external cluster with reliability-metrics (kvisor) installation script.
         * @param {ReportConfigurationAPIApiReportConfigurationAPIGetReliabilityMetricsScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReliabilityMetricsScript(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIGetReliabilityMetricsScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetReliabilityMetricsScriptResponse> {
            return localVarFp.reportConfigurationAPIGetReliabilityMetricsScript(requestParameters.clusterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns reliability-metrics (kvisor) installation script template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReliabilityMetricsScriptTemplate(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reportConfigurationAPIGetReliabilityMetricsScriptTemplate(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a Stripe billing-portal session for the organization\'s customer and returns its URL.
         * @param {ReportConfigurationAPIApiReportConfigurationAPIGetReportingMonetizationBillingPortalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReportingMonetizationBillingPortal(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIGetReportingMonetizationBillingPortalRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetReportingMonetizationBillingPortalResponse> {
            return localVarFp.reportConfigurationAPIGetReportingMonetizationBillingPortal(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the reporting-monetization tier prices (amount, currency, billing interval), fetched live from Stripe so consumers always show current prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReportingMonetizationPrices(options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetReportingMonetizationPricesResponse> {
            return localVarFp.reportConfigurationAPIGetReportingMonetizationPrices(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the reporting-monetization onboarding readiness signals for the organization: which usage milestones (connected cluster, allocation groups, budgets, OpsPilot questions) have already been reached.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReportingMonetizationReadiness(options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetReportingMonetizationReadinessResponse> {
            return localVarFp.reportConfigurationAPIGetReportingMonetizationReadiness(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns the reporting-monetization trial status for an organization.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIGetReportingMonetizationStatus(options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1GetReportingMonetizationStatusResponse> {
            return localVarFp.reportConfigurationAPIGetReportingMonetizationStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks an organization as eligible for the reporting-monetization trial flow. Enables the feature flag for the org and creates a pending trial record.
         * @param {ReportConfigurationAPIApiReportConfigurationAPIMarkOrgEligibleForReportingMonetizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIMarkOrgEligibleForReportingMonetization(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIMarkOrgEligibleForReportingMonetizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.reportConfigurationAPIMarkOrgEligibleForReportingMonetization(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Starts the reporting-monetization trial for an organization. Transitions a pending trial to active and sets started_at/expires_at.
         * @param {ReportConfigurationAPIApiReportConfigurationAPIStartReportingMonetizationTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIStartReportingMonetizationTrial(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIStartReportingMonetizationTrialRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.reportConfigurationAPIStartReportingMonetizationTrial(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates or replaces the CAST AI fee constants for the organization.
         * @param {ReportConfigurationAPIApiReportConfigurationAPIUpdateCastAIFeeConfigRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIUpdateCastAIFeeConfig(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIUpdateCastAIFeeConfigRequest, options?: RawAxiosRequestConfig): AxiosPromise<CostreportV1beta1UpdateCastAIFeeConfigResponse> {
            return localVarFp.reportConfigurationAPIUpdateCastAIFeeConfig(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates organization OAJ state.
         * @param {ReportConfigurationAPIApiReportConfigurationAPIUpdateOAJStateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportConfigurationAPIUpdateOAJState(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIUpdateOAJStateRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.reportConfigurationAPIUpdateOAJState(requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for reportConfigurationAPIChangeReportingMonetizationSubscriptionPlan operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPIChangeReportingMonetizationSubscriptionPlanRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPIChangeReportingMonetizationSubscriptionPlanRequest {
    /**
     * 
     * @type {CostreportV1beta1ChangeReportingMonetizationSubscriptionPlanRequest}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIChangeReportingMonetizationSubscriptionPlan
     */
    readonly body: CostreportV1beta1ChangeReportingMonetizationSubscriptionPlanRequest
}

/**
 * Request parameters for reportConfigurationAPIConfirmReportingMonetizationCheckoutSession operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPIConfirmReportingMonetizationCheckoutSessionRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPIConfirmReportingMonetizationCheckoutSessionRequest {
    /**
     * 
     * @type {CostreportV1beta1ConfirmReportingMonetizationCheckoutSessionRequest}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIConfirmReportingMonetizationCheckoutSession
     */
    readonly body: CostreportV1beta1ConfirmReportingMonetizationCheckoutSessionRequest
}

/**
 * Request parameters for reportConfigurationAPICreateReportingMonetizationCheckoutSession operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPICreateReportingMonetizationCheckoutSessionRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPICreateReportingMonetizationCheckoutSessionRequest {
    /**
     * 
     * @type {CostreportV1beta1CreateReportingMonetizationCheckoutSessionRequest}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPICreateReportingMonetizationCheckoutSession
     */
    readonly body: CostreportV1beta1CreateReportingMonetizationCheckoutSessionRequest
}

/**
 * Request parameters for reportConfigurationAPIGetClusterReportingCapabilities operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilitiesRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilitiesRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilities
     */
    readonly clusterId: string

    /**
     * Filter items to include from specified time.
     * @type {string}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilities
     */
    readonly startTime: string

    /**
     * Filter items to include up to specified time.
     * @type {string}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilities
     */
    readonly endTime: string

    /**
     * 
     * @type {Array<string>}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilities
     */
    readonly filterWorkloadNames?: Array<string>

    /**
     * 
     * @type {'OR' | 'AND'}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilities
     */
    readonly filterLabelsOperator?: ReportConfigurationAPIGetClusterReportingCapabilitiesFilterLabelsOperatorEnum

    /**
     * 
     * @type {Array<string>}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilities
     */
    readonly filterWorkloadTypes?: Array<string>

    /**
     * 
     * @type {Array<string>}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilities
     */
    readonly filterNamespaces?: Array<string>
}

/**
 * Request parameters for reportConfigurationAPIGetEgressdScript operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPIGetEgressdScriptRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPIGetEgressdScriptRequest {
    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIGetEgressdScript
     */
    readonly clusterId: string
}

/**
 * Request parameters for reportConfigurationAPIGetGpuMetricsExporterScript operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPIGetGpuMetricsExporterScriptRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPIGetGpuMetricsExporterScriptRequest {
    /**
     * The ID of the cluster that will install gpu-metrics-exporter.
     * @type {string}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIGetGpuMetricsExporterScript
     */
    readonly clusterId: string
}

/**
 * Request parameters for reportConfigurationAPIGetReliabilityMetricsScript operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPIGetReliabilityMetricsScriptRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPIGetReliabilityMetricsScriptRequest {
    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIGetReliabilityMetricsScript
     */
    readonly clusterId: string
}

/**
 * Request parameters for reportConfigurationAPIGetReportingMonetizationBillingPortal operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPIGetReportingMonetizationBillingPortalRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPIGetReportingMonetizationBillingPortalRequest {
    /**
     * 
     * @type {CostreportV1beta1GetReportingMonetizationBillingPortalRequest}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIGetReportingMonetizationBillingPortal
     */
    readonly body: CostreportV1beta1GetReportingMonetizationBillingPortalRequest
}

/**
 * Request parameters for reportConfigurationAPIMarkOrgEligibleForReportingMonetization operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPIMarkOrgEligibleForReportingMonetizationRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPIMarkOrgEligibleForReportingMonetizationRequest {
    /**
     * 
     * @type {object}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIMarkOrgEligibleForReportingMonetization
     */
    readonly body: object
}

/**
 * Request parameters for reportConfigurationAPIStartReportingMonetizationTrial operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPIStartReportingMonetizationTrialRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPIStartReportingMonetizationTrialRequest {
    /**
     * 
     * @type {object}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIStartReportingMonetizationTrial
     */
    readonly body: object
}

/**
 * Request parameters for reportConfigurationAPIUpdateCastAIFeeConfig operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPIUpdateCastAIFeeConfigRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPIUpdateCastAIFeeConfigRequest {
    /**
     * 
     * @type {CostreportV1beta1UpdateCastAIFeeConfigRequest}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIUpdateCastAIFeeConfig
     */
    readonly body: CostreportV1beta1UpdateCastAIFeeConfigRequest
}

/**
 * Request parameters for reportConfigurationAPIUpdateOAJState operation in ReportConfigurationAPIApi.
 * @export
 * @interface ReportConfigurationAPIApiReportConfigurationAPIUpdateOAJStateRequest
 */
export interface ReportConfigurationAPIApiReportConfigurationAPIUpdateOAJStateRequest {
    /**
     * 
     * @type {CostreportV1beta1UpdateOAJStateRequest}
     * @memberof ReportConfigurationAPIApiReportConfigurationAPIUpdateOAJState
     */
    readonly body: CostreportV1beta1UpdateOAJStateRequest
}

/**
 * ReportConfigurationAPIApi - object-oriented interface
 * @export
 * @class ReportConfigurationAPIApi
 * @extends {BaseAPI}
 */
export class ReportConfigurationAPIApi extends BaseAPI {
    /**
     * 
     * @summary Creates a Stripe plan-change confirmation session for the requested tier and returns its URL. The user is redirected to the Stripe billing portal, which shows the prorated cost of the change before requiring explicit confirmation.
     * @param {ReportConfigurationAPIApiReportConfigurationAPIChangeReportingMonetizationSubscriptionPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIChangeReportingMonetizationSubscriptionPlan(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIChangeReportingMonetizationSubscriptionPlanRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIChangeReportingMonetizationSubscriptionPlan(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirms a completed Stripe Checkout session and persists the subscription (status -> paid).
     * @param {ReportConfigurationAPIApiReportConfigurationAPIConfirmReportingMonetizationCheckoutSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIConfirmReportingMonetizationCheckoutSession(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIConfirmReportingMonetizationCheckoutSessionRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIConfirmReportingMonetizationCheckoutSession(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a Stripe Checkout subscription session for the requested tier and returns its URL.
     * @param {ReportConfigurationAPIApiReportConfigurationAPICreateReportingMonetizationCheckoutSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPICreateReportingMonetizationCheckoutSession(requestParameters: ReportConfigurationAPIApiReportConfigurationAPICreateReportingMonetizationCheckoutSessionRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPICreateReportingMonetizationCheckoutSession(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the CAST AI fee constants configured for the organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetCastAIFeeConfig(options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetCastAIFeeConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns information about the reporting capabilities for a specific cluster.
     * @param {ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetClusterReportingCapabilities(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIGetClusterReportingCapabilitiesRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetClusterReportingCapabilities(requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, requestParameters.filterWorkloadNames, requestParameters.filterLabelsOperator, requestParameters.filterWorkloadTypes, requestParameters.filterNamespaces, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns single command for external cluster with egressd installation script.
     * @param {ReportConfigurationAPIApiReportConfigurationAPIGetEgressdScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetEgressdScript(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIGetEgressdScriptRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetEgressdScript(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns egressd installation script template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetEgressdScriptTemplate(options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetEgressdScriptTemplate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Deprecated] Use Kvisor for gpu-metrics collection. Returns single command for external cluster with gpu-metrics-exporter installation script.
     * @param {ReportConfigurationAPIApiReportConfigurationAPIGetGpuMetricsExporterScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetGpuMetricsExporterScript(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIGetGpuMetricsExporterScriptRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetGpuMetricsExporterScript(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns gpu-metrics-exporter installation script template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetGpuMetricsExporterScriptTemplate(options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetGpuMetricsExporterScriptTemplate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns single command for external cluster with reliability-metrics (kvisor) installation script.
     * @param {ReportConfigurationAPIApiReportConfigurationAPIGetReliabilityMetricsScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetReliabilityMetricsScript(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIGetReliabilityMetricsScriptRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetReliabilityMetricsScript(requestParameters.clusterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns reliability-metrics (kvisor) installation script template.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetReliabilityMetricsScriptTemplate(options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetReliabilityMetricsScriptTemplate(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a Stripe billing-portal session for the organization\'s customer and returns its URL.
     * @param {ReportConfigurationAPIApiReportConfigurationAPIGetReportingMonetizationBillingPortalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetReportingMonetizationBillingPortal(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIGetReportingMonetizationBillingPortalRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetReportingMonetizationBillingPortal(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the reporting-monetization tier prices (amount, currency, billing interval), fetched live from Stripe so consumers always show current prices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetReportingMonetizationPrices(options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetReportingMonetizationPrices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the reporting-monetization onboarding readiness signals for the organization: which usage milestones (connected cluster, allocation groups, budgets, OpsPilot questions) have already been reached.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetReportingMonetizationReadiness(options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetReportingMonetizationReadiness(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns the reporting-monetization trial status for an organization.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIGetReportingMonetizationStatus(options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIGetReportingMonetizationStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks an organization as eligible for the reporting-monetization trial flow. Enables the feature flag for the org and creates a pending trial record.
     * @param {ReportConfigurationAPIApiReportConfigurationAPIMarkOrgEligibleForReportingMonetizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIMarkOrgEligibleForReportingMonetization(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIMarkOrgEligibleForReportingMonetizationRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIMarkOrgEligibleForReportingMonetization(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Starts the reporting-monetization trial for an organization. Transitions a pending trial to active and sets started_at/expires_at.
     * @param {ReportConfigurationAPIApiReportConfigurationAPIStartReportingMonetizationTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIStartReportingMonetizationTrial(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIStartReportingMonetizationTrialRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIStartReportingMonetizationTrial(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates or replaces the CAST AI fee constants for the organization.
     * @param {ReportConfigurationAPIApiReportConfigurationAPIUpdateCastAIFeeConfigRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIUpdateCastAIFeeConfig(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIUpdateCastAIFeeConfigRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIUpdateCastAIFeeConfig(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates organization OAJ state.
     * @param {ReportConfigurationAPIApiReportConfigurationAPIUpdateOAJStateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportConfigurationAPIApi
     */
    public reportConfigurationAPIUpdateOAJState(requestParameters: ReportConfigurationAPIApiReportConfigurationAPIUpdateOAJStateRequest, options?: RawAxiosRequestConfig) {
        return ReportConfigurationAPIApiFp(this.configuration).reportConfigurationAPIUpdateOAJState(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ReportConfigurationAPIGetClusterReportingCapabilitiesFilterLabelsOperatorEnum = {
    OR: 'OR',
    AND: 'AND'
} as const;
export type ReportConfigurationAPIGetClusterReportingCapabilitiesFilterLabelsOperatorEnum = typeof ReportConfigurationAPIGetClusterReportingCapabilitiesFilterLabelsOperatorEnum[keyof typeof ReportConfigurationAPIGetClusterReportingCapabilitiesFilterLabelsOperatorEnum];
